module.exports = __webpack_public_path__ + "assets/img/teacher (34).8bf32c13.png";